<template>
  <div id="index"> 
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              class="mainBread"
            >
              <el-breadcrumb-item>{{$t('menu.Home_View')}}</el-breadcrumb-item>
              <el-breadcrumb-item>{{$t('menu.StationInfo')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <template>
              <el-row :gutter="24" >  
                <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(item,index) in NoticeData" :key="index">
                  <a class="NoticeList" @click="openDialog(item.title)" >
                    <h4 v-if="item.isRead"> {{item.title}}
                    
                      <span class="fr">{{item.pushTime| dateFormat}}</span>
                        <!-- <div  class="fl noticeNew" >new !</div> -->
                      <div class="clear"></div>
                    </h4>
                    <h4 v-else> {{item.title}}
                      <span class="fr">{{item.pushTime| dateFormat}}</span>
                       <!-- <div  class="fr"   style="margin-right:10px;">未读</div> -->
                            <div  class="fl noticeNew" >new !</div>
                      <div class="clear"></div>
                    </h4>
                    <div class=img>
                    <img :src="item.imgUrl" v-if="item.imgUrl" /></div>
                    <div class="info" v-html="item.content">
                      
                      </div>
                      <div class="clear"></div>
                  </a>
                </el-col>
              </el-row>
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pagination.totalPage"
                  :current-page.sync="pagination.current"
                  :page-size="pagination.pageSize"
                  @current-change="getData()"
                  style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </template>
          </el-main>
        </el-scrollbar>
      </el-container>  
    <el-dialog :title="dialogTitle" :visible.sync="dialog" width="60%" top="5vh"> 
      <div class="NoticeDetail">
           <el-row :gutter="24" class="info"  v-for="(item,index) in Detail" :key="index">
            <el-col :md="24" :sm="24" :xs="24">

            <div style="text-align:center;margin-bottom:10px;">{{item.pushTime| dateFormat}}</div> 
          </el-col>  
          <el-col :md="24" :sm="24" :xs="24">
            <div class="info" v-html="item.content"></div> 
          </el-col>  
        </el-row>

        </div>
     
      
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import img from "../../assets/img/shangye.jpg";
import {getMessageByUser,UpdateMesIsRead} from '../../api/api'
export default {
  name: "index",

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  inject: ["reload"],
  data() {
    return {
      dialog: false,
      dialogTitle: "",
      formselect: {
        Keyword:""
      },
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      NoticeData: [
        
      ],
      Detail: [],

      pustForm:{
        id:'',
        pushUserId:'',
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var data = this.formselect
      data.SkipCount = (this.pagination.current - 1) * this.pagination.pageSize
      data.MaxResultCount = this.pagination.pageSize;
      getMessageByUser(data).then(res => {
        
          if (res.success) {
            this.pagination.totalPage = res.result.totalCount
            this.loading = false
            this.NoticeData = res.result.items
          }
      })
     
    },
    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},
    openDialog(title) {
      
      this.dialog = true;
      this.dialogTitle = title;
      var pushmes =  JSON.parse(JSON.stringify( this.search(title)));
        
      this.pustForm.id = pushmes[0].id
      this.pustForm.receiveUserId = pushmes[0].receiveUserId
      if(!pushmes[0].isRead){
        UpdateMesIsRead(this.pustForm).then(res => {
        
          if (res.success) {
              this.reload();
              this.getData();          
          }
        })
      }


    },
    search(title) {
      this.Detail = [];
      this.NoticeData.some((item) => {
        if (item.title == title) {
          this.Detail.push(item);
        }
      });
      return this.Detail;
    },
  },
};
</script>

 
